import Swal from "sweetalert2";

/** Bulk delete quotes with a SweetAlert2 dialog.
 * @param {Array} quoteIds - The list of quotes to delete.
 * @param {function} callback - The callback function to execute after deletion.
 */
export async function bulkDeleteQuotes(payload, callback) {
    let { value } = await Swal.fire({
        title: "Delete Quotes",
        html:
            "Are you sure you want to <strong>Delete</strong> the selected Quotes?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(payload);
    }
}

/** Bulk convert quotes to bookings with a SweetAlert2 dialog.
 * @param {Array} quoteIds - The list of quotes to convert.
 * @param {function} callback - The callback function to execute after conversion.
 */
export async function bulkConvertToBooking(quoteIds, callback) {
    let { value } = await Swal.fire({
        title: "Convert to Booking",
        html: "Are you sure you want to <strong>convert</strong> these quotes to bookings?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        showLoaderOnConfirm: true,
        timerProgressBar: true,
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(quoteIds);
    }
}

/** Export quotes with a SweetAlert2 dialog.
 * @param {Array} payload - The data to export.
 * @param {function} callback - The callback function to execute after exporting.
 */
export async function exportQuotes(payload, callback) {
    let { value } = await Swal.fire({
        title: "Export Quotes",
        html: "Are you sure you want to <strong>export</strong> these quotes?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        showLoaderOnConfirm: true,
        timerProgressBar: true,
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(payload);
    }
}